// @flow
import * as React from "react";

import { Button } from "antd";

import AuthService from "services/auth";

import Actions from "./Actions";
import ThemeToggle from "./Actions/ThemeToggle";
import Navigation from "./Navigation";

const Navbar = {
  LoggedIn(): React.Node {
    const claims = AuthService.getClaims();

    return (
      <>
        <ul className="navbar-nav nav-pills">
          <Navigation claims={claims} />
        </ul>
        <Actions claims={claims} />
      </>
    );
  },
  LoggedOut(): React.Node {
    return (
      <ul className="navbar-nav ms-auto align-items-center">
        <ThemeToggle />

        <li className="nav-item">
          <div className="d-flex align-items-center gap-2">
            <Button href="/login" size="small" color="default" variant="outlined">
              Log in
            </Button>
            <Button href="/signup" size="small" color="primary" variant="solid">
              Sign up
            </Button>
          </div>
        </li>
      </ul>
    );
  },
};

export default Navbar;
